import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ICropsState } from "../shared";

import { CROPS_MODULE_NAME } from "./constants";

const initialState: ICropsState = {
  selectedIds: [],
  searchText: "",
};
export const cropsSlice = createSlice({
  name: CROPS_MODULE_NAME,
  initialState,
  reducers: {
    setSelectedIdsAction(state, action: PayloadAction<string[]>): void {
      state.selectedIds = action.payload;
    },
    toggleId(state, action: PayloadAction<string>): void {
      const id = action.payload;
      if (state.selectedIds.includes(id)) {
        state.selectedIds = state.selectedIds.filter((item) => item !== id);
      } else {
        state.selectedIds = [id, ...state.selectedIds];
      }
    },
    setSearchText(state, action: PayloadAction<string>): void {
      state.searchText = action.payload;
    },
  },
});

export const cropsReducer = cropsSlice.reducer;
export const { setSelectedIdsAction, toggleId, setSearchText } = cropsSlice.actions;
